export class TextTemplateDto {

  public id!: string;
  public value!: string;

  constructor(init?: Partial<TextTemplateDto> | undefined) {
    Object.assign(this, init);
  }
}
